import * as React from 'react';

function SvgIconDashboard(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M0 9a8.011 8.011 0 018-8 8.011 8.011 0 017.999 8.002 7.924 7.924 0 01-1.633 4.848.653.653 0 01-.525.257H2.15a.653.653 0 01-.518-.257A7.923 7.923 0 010 9zm8.653-5.714H7.346v2.063h1.307V3.286zM4.299 9.704H2.232V8.397h2.067v1.307zm2.083.377a1.915 1.915 0 10.801-2.764l-2.8-2.81-.924.924 2.807 2.81a1.91 1.91 0 00.116 1.84zm3.773-4.11l1.469-1.469.916.929-1.47 1.47-.915-.93zM11.7 9.704h2.066V8.397h-2.066v1.307z"
      />
    </svg>
  );
}

export default SvgIconDashboard;
